const CEFMessage = ({ icon, text, classNames, title, html, children }) => (
  <div data-testid="cefMessage" className={`cef-message ${classNames || ''}`}>
    {title ? (
      <div className="fl mb-8">
        {icon && (
          <img
            data-testid="cefMessage-icon"
            className="cef-message__icon v1"
            src={icon}
            width={20}
            height={20}
            alt=""
          />
        )}
        <h3 className="cef-message__title">{title}</h3>
      </div>
    ) : (
      icon && (
        <img
          className="cef-message__icon"
          src={icon}
          width={20}
          height={20}
          alt=""
        />
      )
    )}
    {text && <p className="cef-message__text">{text}</p>}
    {html && (
      <div
        className="cef-message__html"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )}
    {children}
  </div>
);

export default CEFMessage;
